const APPEARANCES = ['system', 'light', 'dark'] as const

// Light while dark mode is in beta; a browser that chose System or Dark keeps its choice (DEC-2026-060).
const DEFAULT_APPEARANCE = 'light'

export { APPEARANCES, DEFAULT_APPEARANCE }
